module.exports = __webpack_public_path__ + "img/1f9ef.0377739.svg";